// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x-FormEditor-formMarker {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00c48322;
  z-index: 9990;
  cursor: pointer;
}
.x-FormEditor-formMarker:hover {
  background-color: #00c48388;
  border: 1px solid #00c483;
}
.x-FormEditor-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #0005;
  z-index: 9991;
}
.x-FormEditor-mainContainer {
  position: fixed;
  background-color: white;
  top: 25px;
  bottom: 25px;
  left: 25px;
  right: 25px;
  border-radius: 10px;
  z-index: 9992;
  padding: 10px 10px 0 10px;
  display: flex;
  flex-direction: column;
}
.x-FormEditor-editorContent {
  flex: 1;
  position: relative;
}
.x-FormEditor-placeholder {
  padding: 3px;
  margin: 3px;
  border: 1px solid #00739d;
  background-color: #e8f0ff;
  font-weight: bold;
}
.x-FormEditor-treeNode {
  margin-left: 10px;
}
.x-FormEditor-treeNodeLabel {
  font-weight: bold;
  cursor: pointer;
  white-space: nowrap;
  padding: 3px 5px;
}
.x-FormEditor-listView > * {
  padding: 5px 10px;
  cursor: pointer;
  white-space: nowrap;
}
.x-FormEditor-listView > *:hover {
  background-color: #62a1d6;
}
.x-FormEditor-fullHeight {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.x-FormEditor-fill {
  flex: 1;
  overflow: auto;
}
.x-FormEditor-title {
  background-color: #f3f6ff;
  border-bottom: 1px solid #c3cbff;
  padding: 2px 3px;
}
.x-FormEditor-mockUp {
  width: 100%;
  height: 100%;
  position: relative;
}
.x-FormEditor-mockUpHint {
  opacity: 0.5;
  position: absolute;
  bottom: 0;
  right: 0;
  border-top: 1px solid #363636;
  border-left: 1px solid #363636;
  background-color: #f8f8f8;
  border-radius: 5px;
  padding: 3px;
  font-weight: bold;
}
.x-FormEditor-misconfigured {
  background-color: salmon;
  padding: 5px;
  font-family: monospace;
}
.x-FormEditor-hoverOverlay {
  position: absolute;
  opacity: 0.8;
  background-color: transparent;
  border: 3px solid #00c483;
  pointer-events: none;
  cursor: pointer;
  z-index: 9994;
}
.x-FormEditor-selectOverlay {
  position: absolute;
  opacity: 0.5;
  background-color: #00739d;
  pointer-events: none;
  z-index: 9993;
}
.x-FormEditor-selectedTreeNode {
  background-color: #00739d;
  color: #fff;
}
.x-FormEditor-highlightedTreeNode {
  background-color: #00c483;
}
.x-FormEditor-designTimeGroup:empty {
  padding: 15px;
  border: 1px dashed #5f82b7;
}
.x-FormEditor-designTimeGroup:empty:after {
  content: '<GROUP>';
  color: #ccc;
}
.north {
  box-shadow: 0 2px 0 #f00 inset;
}
.south {
  box-shadow: 0 -2px 0 #f00 inset;
}
.droppable {
  background-color: #fff3f4;
}
.receiver {
  padding-left: 10px;
}
.receiver.north, .receiver.south {
  box-shadow: none;
}
.receiver.droppable {
  background-color: #fff3f4;
  border: 1px solid #ffb8b5;
}
.editor-highlighted {
  box-shadow: inset 0 0 0 3px #00c483 !important;
}
.editor-selected {
  background-color: #5f82b7 !important;
}
`, "",{"version":3,"sources":["webpack://./modules/portal-core/editor/FormEditor.less"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,eAAA;AAAF;AACE;EACE,2BAAA;EACA,yBAAA;AACJ;AAIA;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,uBAAA;EACA,aAAA;AAFF;AAKA;EACE,eAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EAEA,mBAAA;EAEA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;AALF;AAQA;EACE,OAAA;EACA,kBAAA;AANF;AASA;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;AAPF;AAUA;EACE,iBAAA;AARF;AAWA;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AATF;AAaE;EACE,iBAAA;EACA,eAAA;EAIA,mBAAA;AAdJ;AAWI;EACE,yBAAA;AATN;AAeA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAbF;AAgBA;EACE,OAAA;EACA,cAAA;AAdF;AAiBA;EACE,yBAAA;EACA,gCAAA;EACA,gBAAA;AAfF;AAkBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAhBF;AAmBA;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAjBF;AAoBA;EACE,wBAAA;EACA,YAAA;EACA,sBAAA;AAlBF;AAqBA;EACE,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;AAnBF;AAsBA;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,aAAA;AApBF;AAwBA;EACE,yBAAA;EACA,WAAA;AAtBF;AAwBA;EACE,yBAAA;AAtBF;AA0BE;EACE,aAAA;EACA,0BAAA;AAxBJ;AAyBI;EACE,kBAAA;EACA,WAAA;AAvBN;AA4BA;EAEI,8BAAA;AA3BJ;AAyBA;EAKI,+BAAA;AA3BJ;AAsBA;EAQI,yBAAA;AA3BJ;AAmBA;EAWI,kBAAA;AA3BJ;AA4BI;EACE,gBAAA;AAzBN;AA4BI;EACE,yBAAA;EACA,yBAAA;AA1BN;AAQA;EAuBI,8CAAA;AA5BJ;AAKA;EA4BI,oCAAA;AA9BJ","sourcesContent":["\n.formMarker {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #00c48322;\n  z-index: 9990;\n  cursor: pointer;\n  &:hover {\n    background-color: #00c48388;\n    border: 1px solid #00c483;\n  }\n\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #0005;\n  z-index: 9991;\n}\n\n.mainContainer {\n  position: fixed;\n  background-color: white;\n  top: 25px;\n  bottom: 25px;\n  left: 25px;\n  right: 25px;\n\n  border-radius: 10px;\n\n  z-index: 9992;\n  padding: 10px 10px 0 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.editorContent {\n  flex: 1;\n  position: relative;\n}\n\n.placeholder {\n  padding: 3px;\n  margin: 3px;\n  border: 1px solid #00739d;\n  background-color: #e8f0ff;\n  font-weight: bold;\n}\n\n.treeNode {\n  margin-left: 10px;\n}\n\n.treeNodeLabel {\n  font-weight: bold;\n  cursor: pointer;\n  white-space: nowrap;\n  padding: 3px 5px;\n}\n\n.listView {\n  & > * {\n    padding: 5px 10px;\n    cursor: pointer;\n    &:hover {\n      background-color: #62a1d6;\n    }\n    white-space: nowrap;\n  }\n}\n\n.fullHeight {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.fill {\n  flex: 1;\n  overflow: auto;\n}\n\n.title {\n  background-color: #f3f6ff;\n  border-bottom: 1px solid #c3cbff;\n  padding: 2px 3px;\n}\n\n.mockUp {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.mockUpHint {\n  opacity: 0.5;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  border-top: 1px solid #363636;\n  border-left: 1px solid #363636;\n  background-color: #f8f8f8;\n  border-radius: 5px;\n  padding: 3px;\n  font-weight: bold;\n}\n\n.misconfigured {\n  background-color: salmon;\n  padding: 5px;\n  font-family: monospace;\n}\n\n.hoverOverlay {\n  position: absolute;\n  opacity: 0.8;\n  background-color: transparent;\n  border: 3px solid #00c483;\n  pointer-events: none;\n  cursor: pointer;\n  z-index: 9994;\n}\n\n.selectOverlay {\n  position: absolute;\n  opacity: 0.5;\n  background-color: #00739d;\n  pointer-events: none;\n  z-index: 9993;\n}\n\n\n.selectedTreeNode {\n  background-color: #00739d;\n  color: #fff;\n}\n.highlightedTreeNode {\n  background-color: #00c483;\n}\n\n.designTimeGroup {\n  &:empty {\n    padding: 15px;\n    border: 1px dashed #5f82b7;\n    &:after {\n      content: '<GROUP>';\n      color: #ccc;\n    }\n  }\n}\n\n:global {\n  .north {\n    box-shadow: 0 2px 0 #f00 inset;\n  }\n  .south {\n    box-shadow: 0 -2px 0 #f00 inset;\n  }\n  .droppable {\n    background-color: #fff3f4\n  }\n  .receiver {\n    padding-left: 10px;\n    &.north, &.south {\n      box-shadow: none;\n    }\n\n    &.droppable {\n      background-color: #fff3f4;\n      border: 1px solid #ffb8b5;\n    }\n  }\n\n  .editor-highlighted {\n    box-shadow: inset 0 0 0 3px #00c483 !important;\n    //opacity: 0.8 !important;;\n  }\n\n  .editor-selected {\n    background-color: #5f82b7 !important;\n    //opacity: 0.5 !important;;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formMarker": `x-FormEditor-formMarker`,
	"overlay": `x-FormEditor-overlay`,
	"mainContainer": `x-FormEditor-mainContainer`,
	"editorContent": `x-FormEditor-editorContent`,
	"placeholder": `x-FormEditor-placeholder`,
	"treeNode": `x-FormEditor-treeNode`,
	"treeNodeLabel": `x-FormEditor-treeNodeLabel`,
	"listView": `x-FormEditor-listView`,
	"fullHeight": `x-FormEditor-fullHeight`,
	"fill": `x-FormEditor-fill`,
	"title": `x-FormEditor-title`,
	"mockUp": `x-FormEditor-mockUp`,
	"mockUpHint": `x-FormEditor-mockUpHint`,
	"misconfigured": `x-FormEditor-misconfigured`,
	"hoverOverlay": `x-FormEditor-hoverOverlay`,
	"selectOverlay": `x-FormEditor-selectOverlay`,
	"selectedTreeNode": `x-FormEditor-selectedTreeNode`,
	"highlightedTreeNode": `x-FormEditor-highlightedTreeNode`,
	"designTimeGroup": `x-FormEditor-designTimeGroup`
};
export default ___CSS_LOADER_EXPORT___;
